(function(a){a.session={_id:null,_cookieCache:undefined,_init:function(){if(!window.name){window.name=Math.random()}this._id=window.name;this._initCache();var c=(new RegExp(this._generatePrefix()+"=([^;]+);")).exec(document.cookie);if(c&&document.location.protocol!==c[1]){this._clearSession();for(var b in this._cookieCache){try{window.sessionStorage.setItem(b,this._cookieCache[b])}catch(d){}}}document.cookie=this._generatePrefix()+"="+document.location.protocol+";path=/;expires="+(new Date((new Date).getTime()+120000)).toUTCString()},_generatePrefix:function(){return"__session:"+this._id+":"},_initCache:function(){var c=document.cookie.split(";");this._cookieCache={};for(var b in c){var d=c[b].split("=");if((new RegExp(this._generatePrefix()+".+")).test(d[0])&&d[1]){if(d[0].split(":",3)[2]!="shoppingURL"){this._cookieCache[d[0].split(":",3)[2]]=d[1]}else{this._cookieCache[d[0].split(":",3)[2]]=c[b].substring(c[b].indexOf("=")+1)}}}},_setFallback:function(c,e,d){var b=this._generatePrefix()+c+"="+e+"; path=/";if(d){b+="; expires="+(new Date(Date.now()+120000)).toUTCString()}document.cookie=b;this._cookieCache[c]=e;return this},_getFallback:function(b){if(!this._cookieCache){this._initCache()}return this._cookieCache[b]},_clearFallback:function(){for(var b in this._cookieCache){document.cookie=this._generatePrefix()+b+"=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;"}this._cookieCache={}},_deleteFallback:function(b){document.cookie=this._generatePrefix()+b+"=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";delete this._cookieCache[b]},get:function(b){return window.sessionStorage.getItem(b)||this._getFallback(b)},set:function(b,d,c){try{window.sessionStorage.setItem(b,d)}catch(f){}this._setFallback(b,d,c||false);return this},"delete":function(b){return this.remove(b)},remove:function(b){try{window.sessionStorage.removeItem(b)}catch(c){}this._deleteFallback(b);return this},_clearSession:function(){try{window.sessionStorage.clear()}catch(c){for(var b in window.sessionStorage){window.sessionStorage.removeItem(b)}}},clear:function(){this._clearSession();this._clearFallback();return this}};a.session._init()})(jQuery);

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));
